export function extensionorTerminationofContract2026() {
return [   // Release 2025-12-30 10:14:37
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 258,
   left: 407.76,
   width: 174.12,
   height: 14.16
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 280.92,
   left: 379.2,
   width: 109.92,
   height: 14.16
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 310.68,
   left: 66.84,
   width: 464.88,
   height: 14.16
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 325.8,
   left: 426.0,
   width: 137.76,
   height: 14.16
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 551.28,
   left: 105.6,
   width: 431.16,
   height: 14.16
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 295.856,
   left: 48.4366,
   width: 485.7834,
   height: 14.800
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 356.074,
   left: 46.4729,
   width: 543.3831,
   height: 192.837
}
,
{
   page: 1,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 90.12,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Record Title Deadline and Tax Certificate", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 90.12,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 118.2,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Record Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.2,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 146.28,
   left: 293.04,
   width: 69.72,
   height: 26.76
}
,
{
   page: 1,
   name: "OffRecord Title Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 146.28,
   left: 365.04,
   width: 223.80,
   height: 26.76
}
,
{
   page: 1,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 174.24,
   left: 292.68,
   width: 70.44,
   height: 17.52
}
,
{
   page: 1,
   name: "OffRecord Title Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 174.24,
   left: 364.68,
   width: 224.52,
   height: 17.52
}
,
{
   page: 1,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 193.32,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Title Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 193.32,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 221.4,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.4,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 261.48,
   left: 293.04,
   width: 69.72,
   height: 26.76
}
,
{
   page: 1,
   name: "Association Documents Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 261.48,
   left: 365.04,
   width: 223.80,
   height: 26.76
}
,
{
   page: 1,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 289.8,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Association Documents Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 289.8,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 329.88,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Sellers Property Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 329.88,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 357.96,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 357.96,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 398.04,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "New Loan Application Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 398.04,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 426.12,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "New Loan Terms Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 426.12,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 454.2,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "New Loan Availability Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 454.2,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 482.28,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 482.28,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 510.36,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 510.36,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 538.44,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Existing Loan Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 538.44,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 566.52,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Existing Loan Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 566.52,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 594.6,
   left: 293.04,
   width: 69.72,
   height: 26.76
}
,
{
   page: 1,
   name: "Loan Transfer Approval Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 594.6,
   left: 365.04,
   width: 223.80,
   height: 26.76
}
,
{
   page: 1,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 622.92,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Seller or Private Financing Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 622.92,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 663,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Appraisal Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 663,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 691.08,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Appraisal Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 691.08,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 1,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 719.16,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 1,
   name: "Appraisal Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 719.16,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 90.36,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "New ILC or New Survey Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 90.36,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 118.44,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "New ILC or New Survey Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.44,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 146.52,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "New ILC or New Survey Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 146.52,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 186.6,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Water Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 186.6,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 214.68,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Mineral Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 214.68,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 242.76,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.76,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 270.84,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Inspection Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 270.84,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 298.92,
   left: 293.04,
   width: 69.72,
   height: 26.76
}
,
{
   page: 2,
   name: "Inspection Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 298.92,
   left: 365.04,
   width: 223.80,
   height: 26.76
}
,
{
   page: 2,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 327.24,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Property Insurance Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327.24,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 355.32,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.32,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 383.4,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Due Diligence Documents Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.4,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 411.48,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 411.48,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 439.56,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Conditional Sale Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 439.56,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateEnvironmental Inspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 467.64,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Environmental Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 467.64,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateADA Evaluation Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 495.72,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "ADA Evaluation Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.72,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 523.8,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "LeadBased Paint Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 523.8,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateEstoppel Statements Deadline", 
   fontSize: 9,
   type: "date",
   top: 551.88,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Estoppel Statements Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 551.88,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateEstoppel Statements Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 579.96,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Estoppel Statements Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.96,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DateShort Sale Acceptance Deadline", 
   fontSize: 9,
   type: "date",
   top: 620.28,
   left: 293.28,
   width: 69.24,
   height: 35.64
}
,
{
   page: 2,
   name: "Short Sale Acceptance Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 620.28,
   left: 365.28,
   width: 223.32,
   height: 35.64
}
,
{
   page: 2,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 669.48,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Closing Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.48,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 697.56,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Possession Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 697.56,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 2,
   name: "Possession Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 725.64,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 3,
   name: "DateExtend or Terminate Deadline", 
   fontSize: 9,
   type: "date",
   top: 78.36,
   left: 293.04,
   width: 69.72,
   height: 26.52
}
,
{
   page: 3,
   name: "Acceptance Deadline Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 78.36,
   left: 365.04,
   width: 223.80,
   height: 26.52
}
,
{
   page: 3,
   name: "Acceptance Deadline Time", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 106.08,
   left: 364.68,
   width: 224.52,
   height: 17.52
}
,
{
   page: 3,
   name: "46Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 125.455,
   left: 51.4145,
   width: 24.3601,
   height: 18.240
}
,
{
   page: 3,
   name: " 27Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 124.8,
   left: 76.68,
   width: 29.88,
   height: 18.24
}
,
{
   page: 3,
   name: "Deadline Extra Row Event 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 124.8,
   left: 108.12,
   width: 183.00,
   height: 18.24
}
,
{
   page: 3,
   name: "Date or DeadlineRow3", 
   fontSize: 9,
   type: "date",
   top: 124.8,
   left: 292.68,
   width: 70.44,
   height: 18.24
}
,
{
   page: 3,
   name: "DeadlineRow3_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 124.8,
   left: 364.68,
   width: 224.52,
   height: 18.24
}
,
{
   page: 3,
   name: "undefined", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.76,
   left: 76.8765,
   width: 30.4035,
   height: 22.32
}
,
{
   page: 3,
   name: "Deadline Extra Row Event 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 144.36,
   left: 108.24,
   width: 182.76,
   height: 21.72
}
,
{
   page: 3,
   name: "Date or DeadlineRow4", 
   fontSize: 9,
   type: "date",
   top: 144.36,
   left: 292.8,
   width: 70.2,
   height: 21.72
}
,
{
   page: 3,
   name: "DeadlineRow4_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 144.36,
   left: 364.8,
   width: 224.28,
   height: 21.72
}
,
{
   page: 3,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 349.0,
   left: 118.68,
   width: 450.60,
   height: 13.156
}
,
{
   page: 3,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 400.08,
   left: 119.04,
   width: 450.48,
   height: 13.156
}
,
{
   page: 3,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.92,
   left: 119.04,
   width: 450.48,
   height: 13.156
}
,
{
   page: 3,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 504.0,
   left: 119.04,
   width: 450.48,
   height: 13.156
}
,
{
   page: 3,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 556.08,
   left: 117.84,
   width: 450.36,
   height: 13.156
}
,
{
   page: 3,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 607.92,
   left: 117.84,
   width: 450.48,
   height: 13.156
}
,
{
   page: 3,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 660.0,
   left: 117.84,
   width: 450.48,
   height: 13.156
}
,
{
   page: 3,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 706.2,
   left: 117.48,
   width: 450.60,
   height: 13.1563
}
,
{
   page: 3,
   name: "Other Dates and Deadlines", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 196.71,
   left: 45.8184,
   width: 540.1106,
   height: 97.273
}
,
{
   page: 3,
   name: "Text1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 144.001,
   left: 51.7093,
   width: 24.3600,
   height: 22.000
}
,
{
   page: 4,
   name: "Date Extend Or Terminate Deadline", 
   fontSize: 9,
   type: "date",
   top: 116.4,
   left: 412.8,
   width: 150.96,
   height: 14.16
}
,
{
   page: 4,
   name: "Radiobutton NoticeOfTermination Buyer", 
   isText: false,
   type: "checkbox",
   top: 136.801,
   left: 301.747,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Radiobutton NoticeOfTermination Seller", 
   isText: false,
   type: "checkbox",
   top: 137.455,
   left: 360.002,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "i Inspection  10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 493.967,
   left: 114.131,
   width: 471.274,
   height: 13.113
}
,
{
   page: 4,
   name: "Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 470.64,
   left: 113.28,
   width: 195.48,
   height: 14.16
}
,
{
   page: 4,
   name: "i Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 672.36,
   left: 107.76,
   width: 471.72,
   height: 49.08
}
,
{
   page: 4,
   name: "Check Box6", 
   isText: false,
   type: "checkbox",
   top: 234.983,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box7", 
   isText: false,
   type: "checkbox",
   top: 234.983,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box8", 
   isText: false,
   type: "checkbox",
   top: 253.965,
   left: 64.8003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box9", 
   isText: false,
   type: "checkbox",
   top: 253.965,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box10", 
   isText: false,
   type: "checkbox",
   top: 271.638,
   left: 64.8003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box11", 
   isText: false,
   type: "checkbox",
   top: 271.638,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box12", 
   isText: false,
   type: "checkbox",
   top: 295.856,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box13", 
   isText: false,
   type: "checkbox",
   top: 291.929,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box14", 
   isText: false,
   type: "checkbox",
   top: 324.656,
   left: 64.8003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box15", 
   isText: false,
   type: "checkbox",
   top: 325.311,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box16", 
   isText: false,
   type: "checkbox",
   top: 344.292,
   left: 64.8003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box17", 
   isText: false,
   type: "checkbox",
   top: 343.638,
   left: 323.347,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box18", 
   isText: false,
   type: "checkbox",
   top: 367.856,
   left: 64.8003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box19", 
   isText: false,
   type: "checkbox",
   top: 364.583,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box20", 
   isText: false,
   type: "checkbox",
   top: 396.002,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box21", 
   isText: false,
   type: "checkbox",
   top: 396.656,
   left: 323.347,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box22", 
   isText: false,
   type: "checkbox",
   top: 414.984,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box23", 
   isText: false,
   type: "checkbox",
   top: 414.984,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box24", 
   isText: false,
   type: "checkbox",
   top: 433.966,
   left: 66.1094,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box25", 
   isText: false,
   type: "checkbox",
   top: 433.966,
   left: 323.347,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box26", 
   isText: false,
   type: "checkbox",
   top: 450.984,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box27", 
   isText: false,
   type: "checkbox",
   top: 451.638,
   left: 323.347,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box28", 
   isText: false,
   type: "checkbox",
   top: 475.202,
   left: 66.1094,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box29", 
   isText: false,
   type: "checkbox",
   top: 469.966,
   left: 322.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box30", 
   isText: false,
   type: "checkbox",
   top: 497.457,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box33", 
   isText: false,
   type: "checkbox",
   top: 601.53,
   left: 65.4548,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 4,
   name: "Check Box34", 
   isText: false,
   type: "checkbox",
   top: 619.203,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box35", 
   isText: false,
   type: "checkbox",
   top: 638.185,
   left: 64.8003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box36", 
   isText: false,
   type: "checkbox",
   top: 654.548,
   left: 65.4548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box37", 
   isText: false,
   type: "checkbox",
   top: 673.53,
   left: 64.8003,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton WhoTerminatingContract Buyer", 
   isText: false,
   type: "checkbox",
   top: 89.673,
   left: 56.9457,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 5,
   name: "Radiobutton WhoTerminatingContract Seller", 
   isText: false,
   type: "checkbox",
   top: 89.019,
   left: 119.128,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Client 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 137.24,
   left: 74.52,
   width: 475.32,
   height: 15.054
}
,
{
   page: 5,
   name: "Client 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 220.52,
   left: 74.52,
   width: 475.32,
   height: 15.055
}
,
{
   page: 5,
   name: "Client 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 303.8,
   left: 74.52,
   width: 475.32,
   height: 15.055
}
,
{
   page: 5,
   name: "Client 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 387.08,
   left: 75.1746,
   width: 475.3204,
   height: 15.055
}
] }
